// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: 'false',
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_6276kxrqh',
    userPoolWebClientId: '24et7jck0rusp5mvipnj42jg5l'
  },
  sso_issuers: [
    {
      redirect_uri: 'https://login-dev.vistana.com/sso/authenticate',
      homepage_uri: 'https://login-dev.vistana.com',
      logout_uri: 'https://login-dev.vistana.com/sso/logout',
      logout_endpoint: 'https://login-dev.vistana.com/sso/logout'
    }
  ],

  vistana_baseurl: 'https://dev.vistana.com',
  idp_baseurl: 'https://login-dev.vistana.com',
  api_baseurl: 'https://api-qa.vistana.com/dev',
  api_key: 'qsh878drjwnvky34j8f9599p',
  contactUs: 'https://www.vistana.com/contact-us',
  localization: 'false',
  title: 'VistanaSignatureExperience',
  analytics: '//assets.adobedtm.com/72eef91a8bc6/b6d66cd43a1d/launch-ad6cc004e375-development.min.js',
  ping_companyId: '5de41675-bfa2-4644-968c-48bf441993c8',
  ping_skApiKey: '1f54a845ca7740f72fdba085889e7b02fc3620da4bafec1c92ab1fe3fbf543fe13e98effbe5fd7bc1dea88b5f3cfdc8ab79e75ff61080f184621eccc1c94e58a04ac99cd68d37eb2aaf0d66a4782db43d5f5e2fc2d662fb9204db12e344f6ef2c1ff18562e994bb62683607ac7155b32c5dfa39249236b740d10411046d8c712',
  ping_login_flow_policyId: '1d3457c745fa7e1837f17786704c2fd6',
  ping_manage_account_flow_policyId: '4873c07c2c3798835c119d56563281ec',
  ping_challenge_flow_policyId: '22f08f82778e7c35f5a235e0ae7e0664'
};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
